import { isNotAValue } from "web/services/helpers"
import DayPickerWrapper from "web/components/DayPicker/DayPickerWrapper"
import { render } from "react-dom"
import { Controller } from "@hotwired/stimulus"

export default class DateRangeSelectController extends Controller {
  static targets = ["startDate", "endDate", "renderElement"]

  static outlets = ["class-toggle"]

  connect() {
    this.#storeOriginalValues()

    if (this.hasRenderElementTarget) {
      this.#renderWithCurrentValues()
    }
  }

  reset() {
    this.#resetClassToggle()
    this.startDateTarget.value = this.originalStartDate
    this.endDateTarget.value = this.originalEndDate
    this.#renderWithCurrentValues()
  }

  chooseShortcut(event) {
    this.startDateTarget.value = event.params.startDate || ""
    this.endDateTarget.value = event.params.endDate || ""
  }

  #resetClassToggle() {
    if (!this.hasClassToggleOutlet) return

    if (this.#isHidden !== this.originallyHidden) {
      this.classToggleOutlet.toggle()
    }
  }

  #storeOriginalValues() {
    this.originalStartDate = this.startDateTarget.value
    this.originalEndDate = this.endDateTarget.value
    this.originallyHidden = this.hasClassToggleOutlet && this.#isHidden
  }

  get #isHidden() {
    return this.classToggleOutlet.elementTarget.classList.contains("hidden")
  }

  #renderWithCurrentValues() {
    const from = this.startDateTarget.value
    const to = this.endDateTarget.value
    this.#renderCalendar({
      from,
      to,
      enteredTo: from && to ? to : null,
    })
  }

  #renderCalendar(dateObject) {
    render(
      <DayPickerWrapper
        isRangeDayPicker={true}
        value={dateObject}
        label={this.#selectedDateLabel(dateObject)}
        onChange={(value) => this.#handleChange(value)}
      />,
      this.renderElementTarget
    )
  }

  #selectedDateLabel(dateObject) {
    if (isNotAValue(dateObject.from) || isNotAValue(dateObject.to)) {
      return "Please select a start date"
    }

    return `${dateObject.from} - ${dateObject.to}`
  }

  #handleChange(dateObject) {
    this.startDateTarget.value = dateObject.from
    this.endDateTarget.value = dateObject.to

    this.dispatch("change")

    if (this.#hasBothDates()) {
      this.dispatch("chosen")
    } else if (this.#isMissingAnyDate()) {
      this.dispatch("cleared")
    }

    this.#renderCalendar(dateObject)
  }

  #hasBothDates() {
    return this.startDateTarget.value && this.endDateTarget.value
  }

  #isMissingAnyDate() {
    return !this.startDateTarget.value || !this.endDateTarget.value
  }
}
